import yup, { ErrorLengthMax, ErrorLengthMin } from 'utils/yup-form-validator';

const NB_ERROR = 'Must be a number';

const SourcesManageDataValidator = yup.object({
  name: yup.string()
    .min(3, ErrorLengthMin(3)).max(48, ErrorLengthMax(48)).isAlphanumericHypenBracketSpace()
    .required(),
  mtuTxLink: yup.number().typeError(NB_ERROR).min(1).required(),
  useDefaultMtu: yup.boolean(),
});

export default SourcesManageDataValidator;
